<template>
  <div class="marquee-container" ref="container" @mouseenter="isHovered = true" @mouseleave="isHovered = false">
    <transition name="vue-marquee" @after-enter="restartAnimation" appear>
      <div v-if="show" class="marquee-content" :style="animationStyle" :class="{ 'marquee-paused': isHovered }">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "MarqueeText",
  props: {
    duration: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      isHovered: false,
      show: true,
      containerWidth: 1000,
    };
  },
  mounted() {
    this.updateWidth();
    window.addEventListener("resize", this.updateWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWidth);
  },
  methods: {
    updateWidth() {
      this.$nextTick(() => {
        if (this.$refs.container) {
          this.containerWidth = this.$refs.container.clientWidth || window.innerWidth;
        }
      });
    },
    restartAnimation() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
  computed: {
    animationStyle() {
      return {
        animationDuration: `${this.duration}s`,
        "--start-pos": `${this.containerWidth}px`,
      };
    },
  },
};
</script>

<style scoped>
.marquee-container {
  width: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
}

.marquee-content {
  display: inline-flex;
  white-space: nowrap;
  will-change: transform;
}

/* Vue Transition Animation */
.vue-marquee-enter-active {
  animation: marquee-scroll-left linear;
}

.vue-marquee-leave-active,
.vue-marquee-leave-to {
  display: none;
}

.marquee-paused {
  animation-play-state: paused;
}

@keyframes marquee-scroll-left {
  0% {
    transform: translateX(var(--start-pos, 100vw));
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>
